import Link from 'next/link'
import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { APP_TRANSACTIONS_PATH } from '../../../../../../pages/app/transactions'
import { proxyGlobalAuth } from '../../../../../../shared/proxies/proxyGlobalAuth'

export function Heading (): ReactElement {
  const { siteTheme: { navigationLinkColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <div className="flex justify-between my-3">
      <h4 className="font-semibold opacity-90">Recent Activity</h4>
      <Link href={APP_TRANSACTIONS_PATH}>
        <div className={`${navigationLinkColors.classes} opacity-95 underline text-sm`}>
          View All Transactions
        </div>
      </Link>
    </div>
  )
}
